module.exports = __webpack_public_path__ + "static/media/calor.4f0bf4e1.png";